import {connect} from 'react-redux';

import {makeGetContactsManagerCreateContactFormState} from '../../../../../../../../src/store/panels/contacts/contactsManager/contactsManagerPanelSelectors';
import {
  CreateContactPhoneFormFieldModel,
  CreateContactTwitterHandleFormFieldModel,
  createFormFieldIsEmailField,
  createFormFieldIsPhoneNumberField,
  createFormFieldIsTwitterHandleField,
} from '../../../../../../../../src/store/panels/contacts/createContactForm/createContactFormState';
import {ContactsManagerPanelId} from '../../../../../../../../src/store/panels/panelStateBase';
import {createSelector, makeMapStateToProps} from '../../../../../../../../srcCommon/helpers/reselectHelpers';
import {CreateContactInformation} from './createContactInformation';

/*
 * Props.
 */

interface CreateContactInformationContainerProps {
  panelId: ContactsManagerPanelId;
}

/*
 * Selectors.
 */

function makeGetEmails(
  getContactsManagerCreateContactFormState: ReturnType<typeof makeGetContactsManagerCreateContactFormState>,
) {
  return createSelector([getContactsManagerCreateContactFormState], (formState) => {
    if (!formState) {
      return [];
    }
    return formState.contactFields.filter(createFormFieldIsEmailField);
  });
}

function makeGetPhoneNumbers(
  getContactsManagerCreateContactFormState: ReturnType<typeof makeGetContactsManagerCreateContactFormState>,
) {
  return createSelector(
    [getContactsManagerCreateContactFormState],
    (formState): ReadonlyArray<CreateContactPhoneFormFieldModel> => {
      if (!formState) {
        return [];
      }
      return formState.contactFields.filter(createFormFieldIsPhoneNumberField);
    },
  );
}

function makeGetTwitterHandles(
  getContactsManagerCreateContactFormState: ReturnType<typeof makeGetContactsManagerCreateContactFormState>,
) {
  return createSelector(
    [getContactsManagerCreateContactFormState],
    (formState): ReadonlyArray<CreateContactTwitterHandleFormFieldModel> => {
      if (!formState) {
        return [];
      }
      return formState.contactFields.filter(createFormFieldIsTwitterHandleField);
    },
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CreateContactInformationContainerProps>()(() => {
  const getContactsManagerCreateContactFormState = makeGetContactsManagerCreateContactFormState();
  return {
    emails: makeGetEmails(getContactsManagerCreateContactFormState),
    phoneNumbers: makeGetPhoneNumbers(getContactsManagerCreateContactFormState),
    twitterHandles: makeGetTwitterHandles(getContactsManagerCreateContactFormState),
  };
});

export const CreateContactInformationContainer = connect(mapStateToProps)(CreateContactInformation);
